import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-rective-button',
  templateUrl: './rective-button.component.html',
  styleUrls: ['./rective-button.component.scss']
})
export class RectiveButtonComponent implements OnInit {
disabled: any;
spin: any;

  constructor() { }

  ngOnInit(): void {
  }

}
